import publicationsData from '../data/publications.json';
import { Publication } from '../models/publication.interface';

export class PublicationsService {
    private publications: Publication[] = [];

    constructor() {
        this.publications = publicationsData.publications as Publication[];
    }

    getPublications(): Publication[] {
        return this.publications;
    }
}

export const publicationsService = new PublicationsService();
